import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CustomViewPage from '../../components/CustomComponents/CustomViewPage'
import { useSuperAdmin } from '../../hooks/SuperAdmin/useSuperAdmin'

import { formatDate, formatTime } from '../../shared/constants'

export default function ViewSuperAdmin() {
  const { getSuperAdmin, superAdmin, loading } = useSuperAdmin()
  const params = useParams()

  const [data, setData] = useState([])

  useEffect(() => {
    getSuperAdmin({ superAdminId: params.superAdminId })
  }, [params.superAdminId])

  useEffect(() => {
    if (superAdmin) {
      setData([
        { label: 'Super Admin Code', data: superAdmin.superAdminCode },
        { label: 'Name', data: `${superAdmin.firstName} ${superAdmin.lastName}` },
        { label: 'Email', data: superAdmin.email },
        { label: 'Phone Number', data: superAdmin.phoneNumber },
        { label: 'Date of Birth', data: formatDate(superAdmin.dob) },
      ])
    }
  }, [superAdmin])
  return <CustomViewPage loading={loading} heading="Super Admin" editUrl="superAdmin" id={params.superAdminId} redirect="ALL_SUPERADMINS" data={data} />
}
